"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziContractDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const shares_1 = require("./shares");
const validation_1 = require("./validation");
const PonziContractDeployDialog = (props) => {
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { initialValues: shares_1.emptyShare, validationSchema: validation_1.validationSchema, message: "dialogs.deploy", testId: "PonziContractDeployForm", ...props, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractTemplate", options: types_1.PonziContractTemplates, disabledOptions: [types_1.PonziContractTemplates.SPLITTER] }), (0, jsx_runtime_1.jsx)(shares_1.SharesInput, {})] }));
};
exports.PonziContractDeployDialog = PonziContractDeployDialog;
//# sourceMappingURL=index.js.map